export default __webpack_public_path__ + "static/media/codefi3.3d20f687.png";